export default __webpack_public_path__ + "static/media/custom_threaded_insert.9d25a583.jpg";